import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';

import { AdminModeService } from '../auth/admin-mode/admin-mode.service';
import { AuthorizationWrapper } from './authorization/authorization.wrapper';
import { CustomerSearchWrapper } from './customer-search-page/components/customer-search.wrapper';
import { HeaderContainer } from './header/components/header.container';
import { useI18n } from './i18n/services/i18n.service';
import { BackButtonProviderComponent } from './navigation/components/back-button/back-button-provider.component';
import { ProfilePage } from './profile-page/components/profile.page';
import { trackInput } from './utils/signal/trackInput';
import { WebComponentDirective } from './web-component/web-component.directive';

@Component({
  selector: 'cdf-customer-data-web-component',
  imports: [HeaderContainer, AuthorizationWrapper, ProfilePage, BackButtonProviderComponent, CustomerSearchWrapper],
  host: {
    '[attr.account-number]': 'accountNumber()',
  },
  template: `
    @if (showHeader()) {
      <cdf-header [adminModeWarnReturnToStart]="!!accountNumber()" (returnToStartPage)="accountNumber.set(undefined)" />
    }
    <cdf-authorization-wrapper>
      @if (accountNumber(); as accountNumber) {
        <cdf-back-button-provider
          [label]="i18n('backButton.CUSTOMER_SEARCH')"
          (back)="this.accountNumber.set(undefined)"
        >
          <cdf-profile-page [accountNumber]="accountNumber" />
        </cdf-back-button-provider>
      } @else {
        <cdf-customer-search (openCustomerProfile)="accountNumber.set($event.accountNumber)" />
      }
    </cdf-authorization-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerDataWebComponent extends WebComponentDirective {
  protected readonly i18n = useI18n();

  private readonly adminModeService = inject(AdminModeService);

  readonly showHeader = input(false, { transform: booleanAttribute });
  protected readonly propagateShowHeader = trackInput(this.showHeader, this.adminModeService.adminModeReachable);

  readonly accountNumber = model<string>();
}
